//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricAnalysis.js";
import "../no/Builder.js";
import "../GeometricUtilities/GeometricUtilities.DisplayResolutionBuilder.js";
import "../no/SelectDisplayableObjectList.js";
import "../GeometricAnalysis/GeometricAnalysis.FaceAnalysisNormalsBuilder.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObjectList.js";
let d=[[[1,"DisplayResolution",0,"GeometricUtilities.DisplayResolutionBuilder",1],[0,"FaceReflectivityScale",1,1],[1,"Faces",0,"SelectDisplayableObjectList",1],[0,"FileName",1,1],[0,"ImageMovementType",1,1],[0,"ImagePosition",1,1],[0,"ImageSizeSetting",1,1],[0,"LineImageType",1,1],[0,"LineNumber",1,1],[0,"LineOrientation",1,1],[0,"LineThickness",1,1],[1,"Normals",0,"GeometricAnalysis.FaceAnalysisNormalsBuilder",1],[0,"SceneImageOption",1,1],[0,"ShowFacetEdge",1,1],[0,"Type",1,1]],[[[],"StartReflectionAnalysis",{},0,1]],[]];
SPLM.GeometricAnalysis.ReflectionAnalysisBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricAnalysis.ReflectionAnalysisBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricAnalysis.ReflectionAnalysisBuilder.Types = Object.freeze({
    "LineImages" : "LineImages", "SceneImages" : "SceneImages", "ImageFromFile" : "ImageFromFile"});

SPLM.GeometricAnalysis.ReflectionAnalysisBuilder.LineImageTypes = Object.freeze({
    "BlackLines" : "BlackLines", "BlackandWhiteLines" : "BlackandWhiteLines", "ColoredLines" : "ColoredLines"});

SPLM.GeometricAnalysis.ReflectionAnalysisBuilder.NumberOfLinesOptions = Object.freeze({
    "One" : "One", "Two" : "Two", "Four" : "Four", "Eight" : "Eight", "Sixteen" : "Sixteen", "ThirtyTwo" : "ThirtyTwo", "SixtyFour" : "SixtyFour", "OneTwoEight" : "OneTwoEight", "TwoFiveSix" : "TwoFiveSix"});

SPLM.GeometricAnalysis.ReflectionAnalysisBuilder.LineOrientationType = Object.freeze({
    "Horizontal" : "Horizontal", "Vertical" : "Vertical", "Both" : "Both"});

SPLM.GeometricAnalysis.ReflectionAnalysisBuilder.LineThicknessType = Object.freeze({
    "Thin" : "Thin", "Normal" : "Normal", "Thick" : "Thick"});

SPLM.GeometricAnalysis.ReflectionAnalysisBuilder.SceneImageType = Object.freeze({
    "SimulatedHorizon" : "SimulatedHorizon", "PhotoHorizon" : "PhotoHorizon", "SphericalRoom" : "SphericalRoom", "SphericalLightTubesRoom" : "SphericalLightTubesRoom", "DaytimeHorizon" : "DaytimeHorizon", "MagentaSunset" : "MagentaSunset", "SphericalHorizon" : "SphericalHorizon", "CylindricalRoom" : "CylindricalRoom", "MonochromeHorizon" : "MonochromeHorizon", "SmoothGrayScale" : "SmoothGrayScale", "SharpGrayScale" : "SharpGrayScale", "SphericalTubes" : "SphericalTubes"});

SPLM.GeometricAnalysis.ReflectionAnalysisBuilder.ImageMovementTypes = Object.freeze({
    "Horizontal" : "Horizontal", "Vertical" : "Vertical", "Rotate" : "Rotate"});

SPLM.GeometricAnalysis.ReflectionAnalysisBuilder.ImageSizeOption = Object.freeze({
    "KeepCurrent" : "KeepCurrent", "ReduceScale" : "ReduceScale"});

export default SPLM;